import script from "./CompanyFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyFeatures.vue?vue&type=script&setup=true&lang=js"

import "./CompanyFeatures.vue?vue&type=style&index=0&id=38a36162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a36162"]])

export default __exports__